"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AuthState, createAuthSlice } from "./createAuthSlice";

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get, store) => ({
      ...createAuthSlice(set, get, store),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user_token: state.user_token,
        user_profile: state.user_profile,
      }),
    }
  )
);
